import { useState } from "react";
import { Rocket, Loader2, ExternalLink, CheckCircle2 } from "lucide-react";
import { formatDate } from "./format";

export const DeliveryBox = ({ lead, i, onDeliver }) => {
  const [url, setUrl] = useState(lead.site_url || "");
  const [sending, setSending] = useState(false);

  const send = async () => {
    if (sending || !url.trim()) return;
    if (!window.confirm(`Envoyer l'email « Votre site est en ligne » à ${lead.email} avec le lien ${url.trim()} ?`)) return;
    setSending(true);
    await onDeliver(lead.id, url.trim());
    setSending(false);
  };

  return (
    <div className="mt-4 rounded-2xl border border-navy/10 bg-cream/70 p-4" data-testid={`admin-lead-delivery-${i}`}>
      <p className="flex items-center gap-1.5 font-mono text-[10px] uppercase tracking-[0.18em] text-navy">
        <Rocket size={12} className="text-gold-dark" /> Livraison du site
      </p>
      {lead.delivered_at && (
        <p className="mt-2 inline-flex items-center gap-1.5 rounded-full bg-navy px-3 py-1 text-[11px] font-semibold text-gold" data-testid={`admin-lead-delivered-${i}`}>
          <CheckCircle2 size={11} /> Site publié le {formatDate(lead.delivered_at)}
          <a href={lead.site_url} target="_blank" rel="noreferrer" className="ml-1 inline-flex items-center gap-1 underline underline-offset-2" data-testid={`admin-lead-site-link-${i}`}>
            voir <ExternalLink size={10} />
          </a>
        </p>
      )}
      <div className="mt-3 flex flex-col gap-2 sm:flex-row">
        <input
          data-testid={`admin-lead-site-url-${i}`}
          type="url"
          value={url}
          onChange={(e) => setUrl(e.target.value)}
          placeholder="https://www.site-du-client.fr"
          className="flex-1 rounded-full border border-navy/15 bg-white px-4 py-2 text-xs text-navy outline-none transition-colors focus:border-gold"
        />
        <button
          data-testid={`admin-lead-deliver-${i}`}
          onClick={send}
          disabled={sending || !url.trim() || !lead.email}
          title={!lead.email ? "Ce client n'a pas laissé d'email" : undefined}
          className="flex items-center justify-center gap-1.5 rounded-full bg-navy px-4 py-2 text-xs font-semibold text-white transition-all hover:bg-navy-light disabled:opacity-50"
        >
          {sending ? <Loader2 size={12} className="animate-spin" /> : <Rocket size={12} />}
          {sending ? "Envoi…" : lead.delivered_at ? "Renvoyer la livraison" : "Envoyer la livraison"}
        </button>
      </div>
      {!lead.email && <p className="mt-2 text-[11px] text-slate-400">Pas d'email client : transmettez le lien par téléphone.</p>}
    </div>
  );
};
